import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { DxBaseUiOptions } from "../dx-base-ui-options";
/**
 * Опции компонента dx-page (базовой разметки страницы).
 * @publicApi
 */
let DxPageOptions = class DxPageOptions extends DxBaseUiOptions {
    /**
     * Опции компонента dx-page (базовой разметки страницы).
     * @publicApi
     */
    constructor() {
        super(...arguments);
        /**
         * Флаг скрытия\показа боковой панели страницы.
         * @name _withoutPageSide
         * @type {boolean}
         */
        this._withoutPageSide = true;
        /**
         * Массив дополнительных стилей для контейнера под шапку страницы (дополнительные к `.dx-page__header {...}`).
         * @name _pageHeaderStyles
         * @type {string[]}
         */
        this._pageHeaderStyles = [];
        /**
         * Массив дополнительных стилей для контейнера под боди страницы (дополнительные к `.dx-page__body {...}`).
         * @name _pageBodyStyles
         * @type {string[]}
         */
        this._pageBodyStyles = [];
        /**
         * Массив дополнительных стилей для контейнера под боковую панель страницы (дополнительные к `.dx-page__side {...}`).
         * @name _pageSideStyles
         * @type {string[]}
         */
        this._pageSideStyles = [];
        /**
         * Массив дополнительных стилей для контейнера под контент страницы (дополнительные к `.dx-page__content {...}`).
         * @name _pageContentStyles
         * @type {string[]}
         */
        this._pageContentStyles = [];
        /**
         * Массив дополнительных стилей для контейнера под футер страницы (дополнительные к `.dx-page__footer {...}`).
         * @name _pageContentStyles
         * @type {string[]}
         */
        this._pageFooterStyles = [];
    }
    /**
     * Возвращает флаг скрытия\показа боковой панели страницы.
     * @return {boolean} - флаг скрытия\показа боковой панели страницы.
     */
    get withoutPageSide() {
        return this._withoutPageSide;
    }
    /**
     * Устанавливает флаг скрытия\показа боковой панели страницы.
     * @param {boolean} value - флаг скрытия\показа боковой панели страницы.
     */
    set withoutPageSide(value) {
        this._withoutPageSide = value;
    }
    get pageStyles() {
        return this._pageStyles;
    }
    set pageStyles(value) {
        this._pageStyles = value;
    }
    get pageHeaderStyles() {
        return this._pageHeaderStyles;
    }
    set pageHeaderStyles(value) {
        this._pageHeaderStyles = value;
    }
    get pageBodyStyles() {
        return this._pageBodyStyles;
    }
    set pageBodyStyles(value) {
        this._pageBodyStyles = value;
    }
    get pageSideStyles() {
        return this._pageSideStyles;
    }
    set pageSideStyles(value) {
        this._pageSideStyles = value;
    }
    get pageContentStyles() {
        return this._pageContentStyles;
    }
    set pageContentStyles(value) {
        this._pageContentStyles = value;
    }
    get pageFooterStyles() {
        return this._pageFooterStyles;
    }
    set pageFooterStyles(value) {
        this._pageFooterStyles = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "withoutPageSide", constructor: Boolean, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxPageOptions.prototype, "_withoutPageSide", void 0);
tslib_1.__decorate([
    jsonArrayMember(String, { name: 'pageStyles', isRequired: false, emitDefaultValue: false }),
    tslib_1.__metadata("design:type", Array)
], DxPageOptions.prototype, "_pageStyles", void 0);
tslib_1.__decorate([
    jsonArrayMember(String, { name: 'pageHeaderStyles', isRequired: false, emitDefaultValue: false }),
    tslib_1.__metadata("design:type", Array)
], DxPageOptions.prototype, "_pageHeaderStyles", void 0);
tslib_1.__decorate([
    jsonArrayMember(String, { name: 'pageBodyStyles', isRequired: false, emitDefaultValue: false }),
    tslib_1.__metadata("design:type", Array)
], DxPageOptions.prototype, "_pageBodyStyles", void 0);
tslib_1.__decorate([
    jsonArrayMember(String, { name: 'pageSideStyles', isRequired: false, emitDefaultValue: false }),
    tslib_1.__metadata("design:type", Array)
], DxPageOptions.prototype, "_pageSideStyles", void 0);
tslib_1.__decorate([
    jsonArrayMember(String, { name: 'pageContentStyles', isRequired: false, emitDefaultValue: false }),
    tslib_1.__metadata("design:type", Array)
], DxPageOptions.prototype, "_pageContentStyles", void 0);
tslib_1.__decorate([
    jsonArrayMember(String, { name: 'pageFooterStyles', isRequired: false, emitDefaultValue: false }),
    tslib_1.__metadata("design:type", Array)
], DxPageOptions.prototype, "_pageFooterStyles", void 0);
DxPageOptions = tslib_1.__decorate([
    jsonObject
], DxPageOptions);
export { DxPageOptions };
